export function clampOpacity(value) {
    if (!Number.isFinite(value))
        return 1;
    return Math.max(0, Math.min(1, value));
}
export function resolveEntityItemOpacity(parametricState) {
    return clampOpacity(parametricState?.visualStyle?.opacity ?? 1);
}
function clampOpacity01(value) {
    if (!Number.isFinite(value))
        return 0;
    return Math.max(0, Math.min(1, value));
}
export function deriveOpacityPrecedence(args) {
    const { itemParametricState, baseItemOpacity, activeItemKey, currentItemKey, linkedActiveItemKeys, dimNonActiveOpacity, } = args;
    const explicitOpacity = typeof itemParametricState?.visualStyle?.opacity === 'number'
        && Number.isFinite(itemParametricState.visualStyle.opacity)
        ? clampOpacity01(itemParametricState.visualStyle.opacity)
        : undefined;
    const isExplicitlyHidden = itemParametricState?.visibility?.visible === false;
    // A fully opaque explicit opacity is not a dimming request, and must not preempt highlighting.
    const isExplicitlyDimmed = explicitOpacity !== undefined && explicitOpacity < 1;
    const isActive = activeItemKey === currentItemKey;
    const isLinkedActive = !isActive && (linkedActiveItemKeys?.has(currentItemKey) ?? false);
    const isDimmedNonActive = typeof dimNonActiveOpacity === 'number'
        && Number.isFinite(dimNonActiveOpacity)
        && !isExplicitlyDimmed
        && !isActive
        && !isLinkedActive;
    const resolvedOpacity = isExplicitlyHidden
        ? 0
        : isExplicitlyDimmed
            ? explicitOpacity
            : isDimmedNonActive
                ? clampOpacity01(baseItemOpacity * dimNonActiveOpacity)
                : clampOpacity01(baseItemOpacity);
    return {
        resolvedOpacity,
        explicitOpacity,
        isExplicitlyHidden,
        isExplicitlyDimmed,
        isActive,
        isLinkedActive,
        isDimmedNonActive,
    };
}
